
import { Component, Vue } from 'vue-property-decorator'
import { ClassifiersUtils } from '@/commons/utils/classifiers'
import { applicantStore, classifiersStore } from '@/store'

@Component
export default class ParentInfo extends Vue {
    get idCardReasonLabel (): string {
        return ClassifiersUtils.translateByCode(classifiersStore.applicationReasons, applicantStore.idCard.reason)
    }

    get citizenPassportReasonLabel (): string {
        return ClassifiersUtils.translateByCode(classifiersStore.applicationReasons, applicantStore.citizenPassport.reason)
    }
}
